import dayjs from 'dayjs';

export function createExportProjectFilename(
  projectName: string,
  fileExtension: string,
) {
  const sanitizedName = projectName
    .trim()
    .replace(/[^\w\s-]/g, '')
    .replace(/\s+/g, '_')
    .toLocaleLowerCase();

  const timestamp = dayjs().format('YYYY-MM-DD-HH-mm');

  return `${sanitizedName}-${timestamp}.${fileExtension}`;
}
